const carWiseOfferConfig = {
  taigun: {
    carElements: {
      label: "Taigun",
      key: "taigun",
      price: "Taigun now starting at ₹10 89 900*",
      content: `Limited period offer`,
      subContent: `*T&C Apply`,
      subContent1: ``,
    },
    carFeatureList: [
      {
        featureHeading: "Paddle Shifter",
        description:
          "Shift gears at the flick of a finger. Experience life in the fast lane with the Taigun.",
      },
      {
        featureHeading: "40+ Safety Features",
        description:
          "Swerve safely with the 40 + Safety features on the Taigun. Because safety isn't something we compromise on.",
      },
      {
        featureHeading: "Muscular Elevated Bonnet",
        description:
          "Stand tall with the bold and conspicuous Muscular Elevated Bonnet on the Taigun.",
      },
      {
        featureHeading: "Dual-tone Premium Interior",
        description:
          "The eye-catching dual tone premium interiors are designed to start conversations. And the carbon finish complements the sporty look.",
      },
      {
        featureHeading: `20.32 cm (8") Digital Cockpit`,
        description:
          "Your vibrant persona needs a companion to keep up with your pace. Taigun keeps it classy with a state-of-the-art, customizable user interface that lets you switch between analog and digital formats according to your preference.",
      },
      {
        featureHeading: "Multi-function Steering Wheel",
        description:
          "The VW signature flat-mode multi-function steering wheel allows you to stay on top of your drive.",
      },
    ],
  },
  virtus: {
    carElements: {
      label: "Virtus",
      key: "virtus",
      price: "Virtus now starting at ₹11 55 900*",
      content: `Benefits up to ₹1 80 000*`,
      subContent: `Limited Stock offer`,
      subContent1: `*T&C Apply`,
    },
    carFeatureList: [
      {
        featureHeading: "Active Cylinder Technology",
        description:
          "Get maximum power while keeping fuel consumption in check with Active Cylinder Technology on the 1.5L TSI EVO engine.",
      },
      {
        featureHeading: "6 Airbags",
        description:
          "Safety never takes a backseat in the Virtus. Up to 6 airbags protect the car's occupants in the event of a critical incident.",
      },
      {
        featureHeading: "Big by design",
        description:
          "Second glances are guaranteed with the Virtus' stellar look. Making this all-new sedan stand apart, even when standing still.",
      },
      {
        featureHeading: "Spacious Interiors",
        description:
          "Sit back, stretch out, and relax in Virtus’ spacious interiors.",
      },
      {
        featureHeading: "Wireless Mobile Charging",
        description:
          "With wireless mobile charging, you’re always charged up for a really, really long drive.",
      },
      {
        featureHeading: "Multi-function Steering Wheel",
        description:
          "The sheer thrill of driving meets modern-day convenience with the Virtus' multi-function steering wheel.",
      },
    ],
  },
  tiguan: {
    carElements: {
      label: "Tiguan",
      key: "tiguan",
      price: "Tiguan starting at ₹35 16 900*",
      content: `Exciting benefits up to ₹3 40 000*`,
      subContent: `Offer valid till 30th June 2024`,
      subContent1: `*T&C Apply`,
    },
    carFeatureList: [
      {
        featureHeading: "2.0L TSI Engine",
        description:
          "Power meets performance with the Volkswagen Tiguan. Its revolutionary 2.0L TSI engine offers 190 PS of raw power and 320 Nm torque, making it extremely capable, be it city drives or highway cruises.",
      },
      {
        featureHeading: "New Dual tone Storm Grey Interiors",
        description:
          "Comfort and plushness come together with the new, revamped storm grey interiors in the Volkswagen Tiguan.",
      },
      {
        featureHeading: "New Park Assist (Level 1 ADAS)",
        description:
          "New Park Assist (Level 1 ADAS) on the Volkswagen Tiguan makes urban parking easier and safer with the push of a button.",
      },
      {
        featureHeading: "New Wireless Mobile Charging",
        description: "Skip the hassle of wires with the Volkswagen Tiguan.",
      },
      {
        featureHeading: "7-Speed DSG",
        description:
          "The Tiguan's 7-Speed DSG predicts your next gear shift before you actually make it.",
      },
      {
        featureHeading: "4MOTION with Drive Mode Selector",
        description:
          "Our advanced 4MOTION All-wheel Drive technology keeps the Tiguan gripped firmly to the road.",
      },
    ],
  },
};

export default carWiseOfferConfig;
